import {
  Menu,
  MenuList,
  MenuPopover,
  MenuTrigger,
  makeStyles,
  shorthands,
  tokens,
} from "@fluentui/react-components";
import {
  ChevronDownRegular,
  ChevronUpRegular,
  GlobeRegular,
} from "@fluentui/react-icons";
import React, { useState } from "react";

import { useTranslationLang } from "@/i18n";

import { LanguageSelectMenuItems } from "../LanguageSelectMenuItems";
import { LANGUAGE_SELECT_ENDONYMS, LANGUAGE_SELECT_LABEL } from "../constants";
import { useLanguageSelectMenuCheckedProps } from "../useLanguageSelectMenuCheckedProps";

const DROPDOWN_WIDTH = "312px";

const useStyles = makeStyles({
  trigger: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: DROPDOWN_WIDTH,
    height: "40px",
    paddingLeft: "8px",
    paddingRight: "8px",
    ...shorthands.border("1px", "solid", tokens.colorNeutralStroke1),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    fontFamily: "inherit",
    fontSize: tokens.fontSizeBase300,
    whiteSpace: "nowrap",
    cursor: "pointer",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  label: {
    display: "flex",
    alignItems: "center",
    ...shorthands.gap("8px"),
  },
  currentLang: {
    display: "flex",
    alignItems: "center",
    ...shorthands.gap("4px"),
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
  },
  popover: {
    minWidth: DROPDOWN_WIDTH,
  },
  option: {
    paddingLeft: "34px",
  },
});

/** 未ログイン画面 (ログイン / メール検証) 用の言語切り替えドロップダウン。 */
export const LanguageSelectLoginDropdown: React.FC = () => {
  const styles = useStyles();
  const { lang } = useTranslationLang();
  const languageSelectMenuCheckedProps = useLanguageSelectMenuCheckedProps();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Menu
      {...languageSelectMenuCheckedProps}
      open={isOpen}
      onOpenChange={(_event, data) => setIsOpen(data.open)}
      positioning={{ position: "below", align: "end" }}
    >
      <MenuTrigger disableButtonEnhancement>
        <button type="button" className={styles.trigger}>
          <span className={styles.label}>
            <GlobeRegular fontSize={16} />
            {LANGUAGE_SELECT_LABEL}
          </span>
          <span className={styles.currentLang}>
            {LANGUAGE_SELECT_ENDONYMS[lang]}
            {isOpen ? (
              <ChevronUpRegular fontSize={20} />
            ) : (
              <ChevronDownRegular fontSize={20} />
            )}
          </span>
        </button>
      </MenuTrigger>
      <MenuPopover className={styles.popover}>
        <MenuList>
          <LanguageSelectMenuItems className={styles.option} />
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
